import Api from '../__helpers/api'

//actions
import { handleModal } from './globalModals'

export const getNotifications = page => {
    return async (dispatch, getState) => {
        let data = getState()?.notificationsReducer?.data || {
            items: []
        }
        const pages = getState()?.notificationsReducer?.data?.pages || 1
        if (page > pages) return

        let loading = true

        const handleDispatch = () => dispatch({
            type: 'GET_NOTIFICATIONS',
            payload: {
                loading,
                data,
                page
            },
        })

        handleDispatch()

        Api.get(`notifications/get?page=${page}`)
            .then(res => {
                data = {
                    ...data,
                    ...res.data,
                    items: page == 1 ? res.data.items : [...data.items, ...res.data.items]
                }
            })
            .finally(() => {
                loading = false
                handleDispatch()
            })
    }
}

export const getNotificationsCount = () => {
    return (dispatch, getState) => {
        let loading = true
        let count = 0

        const handleDispatch = () => dispatch({
            type: 'GET_NOTIFICATIONS_COUNT',
            payload: {
                new: {
                    loading,
                    count
                }
            },
        })

        Api.get('notifications/total')
            .then(res => {
                count = res.data
            })
            .catch(() => {
                count = count
            })
            .finally(() => {
                loading = false

                handleDispatch()
            })
    }
}

export const handleNotification = (notificationType, data) => {
    return (dispatch, getState) => {
        if (notificationType == 'startingWithTopics') {
            dispatch(handleModal('MAJOR_GUIDE', true, data))
        } else if (notificationType == 'startingWithTests') {
            dispatch(handleModal('TESTS_GUIDE', true, data))
        } else if (notificationType == 'watchedFirstVideoOfFirstTopic') {
            dispatch(handleModal('WATCHED_FIRST_VIDEO', true, data))
        } else if (notificationType == 'justRegistered') {
            dispatch(handleModal('JUST_REGISTERED', true, data))
        } else if (notificationType == 'feedback') {
            dispatch(handleModal('FEEDBACK', true, data))
        } else if (notificationType == 'justActivated') {
            dispatch(handleModal('JUST_ACTIVATED', true, data))
        } else if (notificationType == 'justConfirmed') {
            dispatch(handleModal('JUST_CONFIRMED', true, data))
        } else if (notificationType == 'activationExpires') {
            dispatch(handleModal('ACTIVATION_EXPIRES', true, data))
        }
    }
}

export const getNotificationOnFocus = () => {
    return async (dispatch, getState) => {
        let notificationOnFocus = {}

        const handleDispatch = () => dispatch({
            type: 'GET_NOTIFICATION_ON_FOCUS',
            payload: {
                notificationOnFocus,
            },
        })

        handleDispatch()

        Api.get('notifications/focus')
            .then(res => {
                notificationOnFocus = res.data
            })
            .finally(() => {
                handleDispatch()
            })
    }
}

export const notificationMarkAsSeen = id => {
    return async (dispatch, getState) => {
        Api.post('notifications/mark-as-seen', {
            id
        })

        const handleDispatch = () => dispatch({
            type: 'NOTIFICATION_MARK_AS_SEEN',
            payload: {
                notificationOnFocus: {
                    title: false
                },
            },
        })

        handleDispatch()
    }
}

export const notificationMarkAsRead = id => {
    return async (dispatch, getState) => {
        Api.post('notifications/mark-as-read', {
            id
        })
            .finally(() => {
                dispatch(refreshNotification())
            })
    }
}

export const refreshNotification = () => {
    return async (dispatch, getState) => {
        dispatch(getNotifications(1))
        dispatch(getNotificationsCount())
        dispatch(getNotificationOnFocus())
    }
}